import { PageTitleBlock } from "../../components/PageTitleBlock/PageTitleBlock";
import styles from "./Tasks.module.scss";
import { JoinChannelBlock } from "./Tasks/JoinChannelTask/JoinChannelBlock";
import { InviteBlock } from "./Tasks/InviteTask/InviteBlock";
import { QuizBlock } from "./Tasks/QuizTask/QuizBlock";
import { addToHomeScreen } from '@telegram-apps/sdk';
import { AddToHomeScreenBlock } from "./Tasks/AddToHomeScreenTask/AddToHomeScreenBlock";
import { isTelegramPlatform } from "../../platform/platform";

export enum TaskContext {
    JoinChannel = 'join-channel',
    VkShare = 'vk-share',
    Invite = 'invite',
    HomeScreenShortcur = 'homescreen-shortcut',
}

export const TasksTypes = () => {
    return (
        <div className={styles.tasksWrapper}>
            <PageTitleBlock
                pageDescription="Минутка кэшфлоу: ловите задания и заполняйте карманы виртуальной валютой!"
            />
            
            <JoinChannelBlock />
            <InviteBlock />
            { /*<VkShareBlock />*/ }
            <QuizBlock />
            { isTelegramPlatform() && addToHomeScreen.isAvailable() && <AddToHomeScreenBlock /> }
        </div>
    );
}